import React, {Fragment, useEffect, useState} from "react";
import {FilePdfOutlined,UploadOutlined,DownloadOutlined} from "@ant-design/icons"
import { Worker } from '@react-pdf-viewer/core';
import { Viewer } from '@react-pdf-viewer/core';
import {Alert, Button, Divider, Form, Input, Upload} from "antd";
import { Trans } from "@lingui/react/macro";
import { t } from "@lingui/core/macro";

export default {
    Renderer: (props) => {
        const data=props.data

        const [loaded,setLoaded]=useState(false)
        useEffect(()=>{
            setLoaded(true)
        },[])

        if(!loaded){
            return null
        }

        const isMobile=props.device === "MOBILE"

        return(
            <div>
                <style>
                    {`
                        .rpv-core__inner-page{
                            background-color:transparent !important;
                        }
                    `}
                </style>
                <Worker workerUrl="/assets/pdfjs/pdf.worker-3.4.120.min.js">
                    {data.pdf && (
                        <Fragment>
                            {!data.previz && (
                                <Viewer fileUrl={data.pdf}/>
                            )}

                            {data.previz && (
                                <div style={{
                                    display: "flex",
                                    flexDirection: "column",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    padding: "20px 0"
                                }}>
                                    <div style={{width: isMobile?"100%":"80%", height: "70vh"}}>
                                        <Viewer
                                            fileUrl={data.pdf}
                                            initialPage={0}
                                            scrollMode={"Page"}
                                            defaultScale={0.6}
                                        />
                                    </div>
                                    <div style={{marginTop:10}}>
                                        <Button icon={<DownloadOutlined/>} href={data.pdf} target={"_blank"}><Trans>Télécharger le document</Trans></Button>
                                    </div>
                                </div>
                            )}
                        </Fragment>

                    )}

                    {!data.pdf && (
                        <Alert showIcon type={"warning"} message={t`Veuillez télécharger un fichier PDF.`}/>
                    )}
                </Worker>
            </div>
        )

    },
    id: 'pdf-viewer',
    title: 'PDF',
    description: "Visionneuse de PDF",
    icon: <FilePdfOutlined/>,
    version: 1,
}


